const baseurl = "^";



const masterTables = {
                        banks:"/banks",
                        branches:"&module=invoice_master_tables",
                        accounts:"&module=invoice_master_tables",
                        universal:"&module=invoice_master_tables"
                    }

const entityLinks= {
    table:"/entity/readentities",
    post:"/entity/createentity",
    put:"/entity/updateentity",
    getItem:"/entity/readentityrow",
    delItem:"/entity/deleteentity",
};
const bankLinks= {
    table:"/bank/readbanks",
    post:"/bank/createbank",
    put:"/bank/updatebank",
    getItem:"/bank/readbankrow",
    delItem:"/bank/deletebank",
};
const branchLinks= {
    table:"/branch/readbranches",
    post:"/branch/createbranch",
    put:"/branch/updatebranch",
    getItem:"/branch/readbranchrow",
    delItem:"/branch/deletebranch",
};
const bankAccountLinks= {
    table:"/bankaccount/readaccounts",
    post:"/bankaccount/createaccount",
    put:"/bankaccount/updateaccount",
    getItem:"/bankaccount/readaccountrow",
    delItem:"/bankaccount/deleteaccount",
};

const billableLinks= {
    table:"/billable/readbillables",
    post:"/billable/createbillable",
    put:"/billable/updatebillable",
    getItem:"/billable/readbillablerow",
    delItem:"/billable/deletebillable",
};

const taxLinks= {
    table:"/tax/readtaxes",
    post:"/tax/createtax",
    put:"/tax/updatetax",
    getItem:"/tax/readtaxrow",
    delItem:"/tax/deletetax",
};

const payeeEntityLinks= {
    table:"/pentity/readpentities",
    post:"/pentity/createpentity",
    put:"/pentity/updatepentity",
    getItem:"/pentity/readpentityrow",
    delItem:"/pentity/deletepentity",
};

const invoiceTemplateLinks= {
    table:"/invtemp/readinvtemps",
    post:"/invtemp/createinvtemp",
    put:"/invtemp/updateinvtemp",
    getItem:"/invtemp/readinvtemprow",
    delItem:"/invtemp/deleteinvtemp",
};

const invoiceLinks= {
    generate:"/invoice/generateinvoice",
    table:"/invoice/readinvoices",
    post:"/invoice/createinvoice",
    put:"/invoice/updateinvoice",
    getItem:"/invoice/readinvoicerow",
    delItem:"/invoice/deleteinvoice",
};

const changeLogLinks = {
    readForInvoice: "/changelog/readchangelogs",
};

const userLinks = {
    post: "/user/createuser",
    table:  "/user/readuser",
    getItem: "/user/readuserrow",
    updateStatus: "/user/updateuserstatus",
    resetPassword: "/user/adminresetpassword",
    readGroups: "/user/readusergroups",
    updateGroups: "/user/updateusergroups",
};

const entityHeaderLinks = {
    table: "/entityheader/readheaders",
    getItem: "/entityheader/readheaderrow",
    post: "/entityheader/createheader",
    put: "/entityheader/updateheader",
    delItem: "/entityheader/deleteheader",
    image: "/entityheader/image",
};

const dropDownLinks={
    taxes:"/tax/gettaxnames",
    banks:"/bank/listbanks",
    branches:"/branch/listbranches",
    accounts:"/bankaccount/getaccountnames",
    pentities:"/pentity/getpentitynames",
    billables:"/billable/getbillablenames",
    invtemps:"/invtemp/getinvtempnames",
    invoices:"/invoice/getinvoicelist",
};

const dropDown =baseurl+masterTables['universal']+"&method=dropDownTable"


export {bankLinks, branchLinks, dropDown, bankAccountLinks, entityLinks, billableLinks, dropDownLinks,taxLinks,payeeEntityLinks,invoiceTemplateLinks, invoiceLinks, changeLogLinks, userLinks, entityHeaderLinks};
